// 星幣牌組 (Suit of Pentacles) - 14張
// 使用 Wikipedia Commons 官方圖庫確保穩定性
const pentaclesImages = {
  1: 'https://upload.wikimedia.org/wikipedia/commons/f/fd/Pents01.jpg',
  2: 'https://upload.wikimedia.org/wikipedia/commons/9/9f/Pents02.jpg',
  3: 'https://upload.wikimedia.org/wikipedia/commons/4/42/Pents03.jpg',
  4: 'https://upload.wikimedia.org/wikipedia/commons/3/35/Pents04.jpg',
  5: 'https://upload.wikimedia.org/wikipedia/commons/9/96/Pents05.jpg',
  6: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/Pents06.jpg',
  7: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Pents07.jpg',
  8: 'https://upload.wikimedia.org/wikipedia/commons/4/49/Pents08.jpg',
  9: 'https://upload.wikimedia.org/wikipedia/commons/f/f0/Pents09.jpg',
  10: 'https://upload.wikimedia.org/wikipedia/commons/4/42/Pents10.jpg',
  11: 'https://upload.wikimedia.org/wikipedia/commons/e/ec/Pents11.jpg',
  12: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/Pents12.jpg',
  13: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Pents13.jpg',
  14: 'https://upload.wikimedia.org/wikipedia/commons/1/1c/Pents14.jpg'
};

export const pentacles = [
  {
    id: 'p1',
    name: '星幣一',
    nameEn: 'Ace of Pentacles',
    img: pentaclesImages[1],
    upright: {
      keywords: ['新機會', '物質豐盛', '穩定基礎', '潛力'],
      meaning: '在工作、財務或健康上出現了一個實質的新機會。這是一顆種子,只要用心栽培,就能帶來豐碩的現實成果。'
    },
    reversed: {
      keywords: ['錯失良機', '財務規劃不佳', '缺乏基礎'],
      meaning: '你可能錯失了一個實質的機會,或者因為缺乏周全的計畫,導致資源流失。'
    }
  },
  {
    id: 'p2',
    name: '星幣二',
    nameEn: 'Two of Pentacles',
    img: pentaclesImages[2],
    upright: {
      keywords: ['平衡', '適應力', '時間管理', '波動'],
      meaning: '你正在多項事務(如工作與生活)之間尋求平衡。保持靈活與適應力,你能夠駕馭這種波動。'
    },
    reversed: {
      keywords: ['失衡', '不堪重負', '財務混亂'],
      meaning: '你手上的球太多,已經快要接不住了。需要重新檢視優先順序,不要讓自己過度勞累。'
    }
  },
  {
    id: 'p3',
    name: '星幣三',
    nameEn: 'Three of Pentacles',
    img: pentaclesImages[3],
    upright: {
      keywords: ['團隊合作', '專業技能', '計畫', '認可'],
      meaning: '這是一個強調合作與專業的時刻。透過與他人的技能互補,你們正在建立一個穩固且有價值的成果。'
    },
    reversed: {
      keywords: ['缺乏合作', '品質不佳', '各自為政'],
      meaning: '團隊中出現了摩擦,或者因為缺乏共識與專業精神,導致工作進度受到影響。'
    }
  },
  {
    id: 'p4',
    name: '星幣四',
    nameEn: 'Four of Pentacles',
    img: pentaclesImages[4],
    upright: {
      keywords: ['保守', '安全感', '穩定', '控制欲'],
      meaning: '你極力保護自己所擁有的資源。這雖然帶來了安全感,但也可能讓你變得過於保守,不敢做出投資或改變。'
    },
    reversed: {
      keywords: ['貪婪', '物質主義', '放手'],
      meaning: '你可能過度執著於金錢與物質;或者相反地,你終於學會了放下對物質的過度控制。'
    }
  },
  {
    id: 'p5',
    name: '星幣五',
    nameEn: 'Five of Pentacles',
    img: pentaclesImages[5],
    upright: {
      keywords: ['匱乏', '孤立', '艱難', '健康問題'],
      meaning: '你正經歷一段物質或心靈上的寒冬,感到被孤立無援。但請抬起頭,幫助其實就在你附近,只是你沒看見。'
    },
    reversed: {
      keywords: ['脫離困境', '財務復甦', '精神回暖'],
      meaning: '最艱難的時刻已經過去,你正在慢慢恢復元氣,重新找回生活中的溫暖與安全感。'
    }
  },
  {
    id: 'p6',
    name: '星幣六',
    nameEn: 'Six of Pentacles',
    img: pentaclesImages[6],
    upright: {
      keywords: ['慷慨', '施與受', '慈善', '財務平衡'],
      meaning: '這是一個關於資源分享的牌。你可能處於給予者的位置去幫助他人,或者有幸成為接受幫助的那一方。'
    },
    reversed: {
      keywords: ['自私', '債務', '不平等的關係'],
      meaning: '在給予或接受的過程中出現了不平衡。可能是單方面的付出,或者是因為負債而感到受制於人。'
    }
  },
  {
    id: 'p7',
    name: '星幣七',
    nameEn: 'Seven of Pentacles',
    img: pentaclesImages[7],
    upright: {
      keywords: ['耐心', '評估', '長期投資', '等待收穫'],
      meaning: '你已經付出了很多努力,現在是停下來評估成果的時候。耐心等待,你的投資終將迎來豐收。'
    },
    reversed: {
      keywords: ['缺乏耐心', '投資失利', '努力白費'],
      meaning: '你可能對進展緩慢感到沮喪,或者發現自己把精力投資在了錯誤的地方,沒有得到應有的回報。'
    }
  },
  {
    id: 'p8',
    name: '星幣八',
    nameEn: 'Eight of Pentacles',
    img: pentaclesImages[8],
    upright: {
      keywords: ['專注', '工匠精神', '技能提升', '勤奮'],
      meaning: '這是一個專心致志的時期。你正在精進自己的專業技能,透過日復一日的努力,打造出高品質的成果。'
    },
    reversed: {
      keywords: ['完美主義', '缺乏專注', '工作倦怠'],
      meaning: '你可能陷入了死板的完美主義,或者因為缺乏動力而對重複性的工作感到極度倦怠。'
    }
  },
  {
    id: 'p9',
    name: '星幣九',
    nameEn: 'Nine of Pentacles',
    img: pentaclesImages[9],
    upright: {
      keywords: ['獨立', '享受成果', '自給自足', '優雅'],
      meaning: '經過長期的努力,你終於達到了獨立與豐盛的狀態。現在可以優雅地享受你親手建立起來的美好生活了。'
    },
    reversed: {
      keywords: ['過度工作', '表面風光', '缺乏獨立性'],
      meaning: '你可能為了物質放棄了太多個人時間,或者表面看似富足,內心卻依然覺得缺乏安全感。'
    }
  },
  {
    id: 'p10',
    name: '星幣十',
    nameEn: 'Ten of Pentacles',
    img: pentaclesImages[10],
    upright: {
      keywords: ['傳承', '家族財富', '長期穩定', '傳統'],
      meaning: '這代表著終極的物質穩定與長遠的傳承。不僅是財富的累積,更是家庭、事業與傳統價值的穩固基礎。'
    },
    reversed: {
      keywords: ['財務危機', '家庭紛爭', '打破傳統'],
      meaning: '穩固的基礎可能出現了動搖,例如財務上的重大損失,或者是家族、公司內部出現了價值觀的衝突。'
    }
  },
  {
    id: 'p11',
    name: '星幣侍者',
    nameEn: 'Page of Pentacles',
    img: pentaclesImages[11],
    upright: {
      keywords: ['踏實', '學習', '新計畫', '具體化'],
      meaning: '這是一個關於學習新技能或啟動新計畫的好時機。你擁有將夢想具體化的潛力,只要一步一腳印去實踐。'
    },
    reversed: {
      keywords: ['拖延', '缺乏計畫', '無法專注'],
      meaning: '你可能有很多想法,但卻缺乏將其落實的執行力,或者在學習上遇到了瓶頸。'
    }
  },
  {
    id: 'p12',
    name: '星幣騎士',
    nameEn: 'Knight of Pentacles',
    img: pentaclesImages[12],
    upright: {
      keywords: ['負責', '按部就班', '勤懇', '可靠'],
      meaning: '你像是一頭穩健的牛,不急躁但非常踏實。你對目標有著極高的責任感,能夠堅持不懈地完成任務。'
    },
    reversed: {
      keywords: ['固執', '無趣', '懶散', '停滯'],
      meaning: '你可能變得過度固執,拒絕任何改變;或者相反地,失去了動力,變得極度懶散與拖延。'
    }
  },
  {
    id: 'p13',
    name: '星幣皇后',
    nameEn: 'Queen of Pentacles',
    img: pentaclesImages[13],
    upright: {
      keywords: ['滋養', '務實', '豐富', '安全感'],
      meaning: '你是一位實用的照顧者,能夠在物質與情感上為周圍的人提供豐富的滋養與安全感。'
    },
    reversed: {
      keywords: ['過度保護', '物質至上', '忽視自我'],
      meaning: '你可能為了照顧別人而把自己消耗殆盡,或者變得過度看重物質與金錢,失去了內心的柔軟。'
    }
  },
  {
    id: 'p14',
    name: '星幣國王',
    nameEn: 'King of Pentacles',
    img: pentaclesImages[14],
    upright: {
      keywords: ['豐富', '成功', '企業家', '穩定力量'],
      meaning: '你已經達到了世俗標準的成功,擁有強大的掌控力與豐富的資源。這是一個能提供穩定基礎與庇護的角色。'
    },
    reversed: {
      keywords: ['貪婪', '腐敗', '物質執著', '固執'],
      meaning: '你可能被金錢蒙蔽了雙眼,變得過度貪婪或物質主義,甚至為了利益而不擇手段。'
    }
  }
];